module.exports = __webpack_public_path__ + "static/media/mapa-a4.6423c384.png";